// extracted by mini-css-extract-plugin
export default {"root":"TagsInput_root__Wel8s","tags":"TagsInput_tags__m2e2s","tag":"TagsInput_tag__zOhFE","removeTag":"TagsInput_removeTag__2PHgV"};